/**
 * 统一商标状态文本，供翻译字典键和爬虫状态使用相同的匹配口径。
 */
export function normalizeTrademarkStatus(status: string): string {
  return status
    .normalize('NFKC')
    .replace(/\s+/gu, ' ')
    .trim()
    .toLowerCase();
}
